import { Shape } from '@tokamap/core';

export const POLYGON = {
	id: 1,
	reference: 'polygon',
	label: 'Polygone',
	geoJsonType: 'Polygon',
	urn: '$:map:feature_type:1',
};

export const RECTANGLE = {
	id: 5,
	reference: 'rectangle',
	label: 'Rectangle',
	geoJsonType: 'Polygon',
	urn: '$:map:feature_type:5',
};

export const CIRCLE = {
	id: 4,
	reference: 'circle',
	label: 'Cercle',
	geoJsonType: 'LineString',
	urn: '$:map:feature_type:4',
};

export const POINT = {
	id: 2,
	reference: 'point',
	label: 'Point',
	geoJsonType: 'Point',
	urn: '$:map:feature_type:2',
};

const featureTypes = [
	POLYGON,
	POINT,
	{
		id: 3,
		reference: 'line',
		label: 'Ligne',
		geoJsonType: 'LineString',
		urn: '$:map:feature_type:3',
	},
	CIRCLE,
	RECTANGLE,
	{
		id: 6,
		reference: 'square',
		label: 'Carré',
		geoJsonType: 'Polygon',
		urn: '$:map:feature_type:6',
	},
];

export const featureTypeByUrn = featureTypes.reduce<Record<string, typeof featureTypes[number]>>((acc, item) => {
	acc[item['urn']] = item;
	return acc;
}, {});

export const featureTypeByReference = featureTypes.reduce<Record<string, typeof featureTypes[number]>>((acc, item) => {
	acc[item['reference']] = item;
	return acc;
}, {});

const API_REFERENCE_BY_SHAPE_KIND: Partial<Record<NonNullable<Shape['shapeKind']>, string>> = {
	image: 'rectangle',
	marker: 'point',
	decor: 'point',
};

export function featureTypeOfShape(shape: Shape) {
	const shapeKind = shape.shapeKind ?? 'polygon';

	return featureTypeByReference[API_REFERENCE_BY_SHAPE_KIND[shapeKind] ?? shapeKind]!;
}

export default featureTypes;